// import React, { useState, useEffect, useRef, useMemo } from "react";
// import Select from "react-select";
// import { FaWhatsapp } from "react-icons/fa";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import AutoMessageService from "../../Services/AutoMessageService";
// import { interestLevel } from "../../../Enum";
// import { userId, userUid } from "../../Constant/Constant";
// import { showSuccessToast } from "../../Constant/Notification";

// const AutoMessageModel = ({ selectedDataId, isOpen, close }) => {
//   const [messageTypes, setMessageTypes] = useState([]);
//   const [selectedMessage, setSelectedMessage] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [selectedLevels, setSelectedLevels] = useState([]);
//   const [messageContent, setMessageContent] = useState("");
//   const [contentError, setContentError] = useState("");
//   const [leadStatuses, setLeadStatuses] = useState([]);
//   const [leadQualities, setLeadQualities] = useState([]);
//   const [parameterChips, setParameterChips] = useState([]);
//   const [isActive, setIsActive] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [platform, setPlatform] = useState("");
//   const [waTemplateId, setWaTemplateId] = useState("");
//   const [waTemplateName, setWaTemplateName] = useState("");
//   const [createdTimestamp, setCreatedTimestamp] = useState("");
//   const [updatedTimestamp, setUpdatedTimestamp] = useState("");
//   const [metaApproved, setMetaApproved] = useState("");

//   const quillRef = useRef(null);

//   const modules = useMemo(
//     () => ({
//       toolbar: [
//         [{ header: [1, 2, 3, 4, 5, 6, false] }],
//         ["bold", "italic", "underline", "strike"],
//         [{ list: "ordered" }, { list: "bullet" }],
//         [{ color: [] }, { background: [] }],
//         ["link"],
//         ["clean"],
//       ],
//     }),
//     []
//   );

//   const customStyles = useMemo(
//     () => ({
//       control: (provided) => ({
//         ...provided,
//         backgroundColor: "transparent",
//         border: "none",
//         boxShadow: "none",
//         minHeight: "40px",
//       }),
//       option: (provided, state) => ({
//         ...provided,
//         backgroundColor: state.isSelected ? "#22C55E" : "white",
//         color: state.isSelected ? "white" : "black",
//         cursor: "pointer",
//         "&:hover": {
//           backgroundColor: state.isSelected ? "#22C55E" : "#f3f4f6",
//         },
//       }),
//       multiValue: (provided) => ({
//         ...provided,
//         backgroundColor: "#e2f8e9",
//       }),
//       multiValueLabel: (provided) => ({
//         ...provided,
//         color: "#22C55E",
//       }),
//     }),
//     []
//   );

//   useEffect(() => {
//     if (!isOpen) return;

//     const fetchData = async () => {
//       setIsLoading(true);
//       try {
//         const response = await AutoMessageService.creactionDataAutoMessage();
//         const {
//           messageType = [],
//           leadStatus = [],
//           leadQualities = [],
//         } = response.data || {};

//         setMessageTypes(messageType);
//         setLeadStatuses(leadStatus);
//         setLeadQualities(leadQualities);
//       } catch (error) {
//         console.error("Error fetching auto message creation data:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchData();
//   }, [isOpen]);

//   // Fetch existing data if editing
//   useEffect(() => {
//     if (!selectedDataId || !isOpen) return;

//     const fetchAutoMessage = async () => {
//       setIsLoading(true);
//       try {
//         const response = await AutoMessageService.getAutoMessageById(
//           selectedDataId
//         );
//         const data = response.data || {};

//         setIsActive(data.active === true);
//         setMessageContent(data.messageContent || "");

//         if (data.leadStatus) {
//           setSelectedStatus(data.leadStatus.ref || "");
//         }

//         if (data.leadQualities?.length) {
//           const qualityOptions = data.leadQualities.map((quality) => ({
//             value: quality.ref,
//             label: quality.name,
//             ...quality,
//           }));
//           setSelectedLevels(qualityOptions);
//         }

//         if (data.messageType) {
//           const messageTypeData = {
//             id: data.messageType.ref.split("/")[1],
//             name: data.messageType.name,
//             parameters:
//               data.dynamicValuesMapping?.map((item) => item.fieldName) || [],
//           };
//           setSelectedMessage(messageTypeData);
//           updateParameterChips(messageTypeData.parameters);
//         }

//         setPlatform(data.platform || "");
//         setWaTemplateId(data.waTemplateId || "");
//         setWaTemplateName(data.waTemplateName || "");
//         setCreatedTimestamp(data.createdTimestamp || "");
//         setUpdatedTimestamp(data.updatedTimestamp || "");
//         setMetaApproved(data.metaApproved || "");
//       } catch (error) {
//         console.error("Error fetching auto message:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchAutoMessage();
//   }, [selectedDataId, isOpen]);

//   useEffect(() => {
//     if (!isOpen || selectedDataId) return;

//     setSelectedMessage(null);
//     setSelectedStatus("");
//     setSelectedLevels([]);
//     setParameterChips([]);
//     setMessageContent("");
//     setIsActive(false);
//     setPlatform("");
//     setWaTemplateId("");
//     setWaTemplateName("");
//     setCreatedTimestamp("");
//     setUpdatedTimestamp("");
//     setMetaApproved("");
//     setContentError("");
//     setIsSubmitting(false);
//   }, [isOpen, selectedDataId]);

//   const updateParameterChips = (parameters) => {
//     if (!parameters?.length) {
//       setParameterChips([]);
//       return;
//     }

//     const chips = parameters.map((param, index) => ({
//       id: param,
//       label: param.replace(/_/g, " "),
//       placeholder: `{{${index + 1}}}`,
//     }));

//     setParameterChips(chips);
//   };

//   const handleMessageChange = (selectedOption) => {
//     if (!selectedOption) {
//       setSelectedMessage(null);
//       setParameterChips([]);
//       return;
//     }

//     const selected = messageTypes.find((mt) => mt.id === selectedOption.value);
//     if (!selected) return;

//     setSelectedMessage(selected);
//     updateParameterChips(selected.parameters);
//   };

//   const validateMessageContent = (content) => {
//     if (!content || content === "<p><br></p>") {
//       setContentError("Message content cannot be empty");
//       return false;
//     }

//     const plainText = content.replace(/<[^>]*>/g, "").trim();

//     const startsWithParam = /^\{\{\d+\}\}/.test(plainText);
//     const endsWithParam = /\{\{\d+\}\}$/.test(plainText);

//     if (startsWithParam) {
//       setContentError("Message cannot start with a parameter");
//       return false;
//     } else if (endsWithParam) {
//       setContentError("Message cannot end with a parameter");
//       return false;
//     } else {
//       setContentError("");
//       return true;
//     }
//   };

//   const getBackgroundClass = (name) => {
//     switch (name?.toLowerCase()) {
//       case "gold":
//         return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
//       case "silver":
//         return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
//       case "bronze":
//         return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
//       case "diamond":
//         return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
//       default:
//         return "text-black";
//     }
//   };

//   const insertParameterChip = (placeholder) => {
//     if (!quillRef.current) return;

//     const quill = quillRef.current.getEditor();
//     const range = quill.getSelection(true);
//     if (!range) {
//       quill.setSelection(0, 0);
//       return;
//     }

//     const currentContent = quill.getText();
//     const cursorPosition = range.index;

//     const wouldBeAtStart = cursorPosition === 0;
//     const wouldBeAtEnd = cursorPosition === currentContent.length;

//     if (wouldBeAtStart || wouldBeAtEnd) {
//       setContentError("Cannot add parameter at the beginning or end");
//       return;
//     }

//     quill.insertText(range.index, `${placeholder} `);
//     quill.setSelection(range.index + placeholder.length + 1);
//   };

//   const toggleActiveStatus = async () => {
//     try {
//       const payload = {
//         templateId: selectedDataId,
//         active: !isActive,
//       };

//       const response = await AutoMessageService.statusUpdateAutoMessage(
//         payload
//       );
//       console.log("Status update response:", response);
//       if (response.status == 200) {
//        // console.log("Status updated successfully");
//         setIsActive(!isActive);

//         showSuccessToast("Status updated successfully");
//         close();
//       }
//     } catch (error) {
//       console.error("Error toggling auto message status:", error);
//     }
//     setIsActive(!isActive);
//   };

//   const handleSubmit = async () => {
//     if (!selectedMessage || !selectedLevels.length || !selectedStatus) {
//       return;
//     }

//     if (!validateMessageContent(messageContent)) {
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       const dynamicValuesMapping = parameterChips.map((chip, index) => ({
//         number: `${index + 1}`,
//         fieldName: chip.id,
//       }));

//       const payload = {
//         messageType: `messageType/${selectedMessage.id}`,
//         leadQualities: selectedLevels.map((level) => level.value || level.ref),
//         leadStatus: selectedStatus,
//         messageContent: messageContent,

//         dynamicValuesMapping: dynamicValuesMapping,
//       };

//       if (selectedDataId) {
//         Object.assign(payload, {
//           templateId: selectedDataId,
//           modifiedBy: userUid,
//           waTemplateName: waTemplateName,
//           waTemplateId: waTemplateId,
//         });

//         console.log("Update payload:", payload);

//         const response = await AutoMessageService.updateAutoMessage(payload);
//         console.log("Update response:", response);
//         if (response.status === 200) {
//           showSuccessToast("Automation message updated successfully");
//           close();
//         }

//       } else {
//         Object.assign(payload, {
//           createdBy: userUid,
//         });

//         const response = await AutoMessageService.createAutoMessage(payload);
//         console.log("Create response:", response);
//         if (response.status === 200) {
//           showSuccessToast("Automation message created successfully");
//           close();
//         }

//       }

//       close();
//     } catch (error) {
//       console.error(
//         "Error submitting form:",
//         error.response?.data || error.message || error
//       );
//       alert(
//         "Error: " +
//           (error.response?.data?.message ||
//             error.message ||
//             "Failed to save automation message")
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 py-6 z-50">
//       <div className="bg-white p-5 rounded-xl shadow-xl w-full max-w-4xl mx-auto max-h-[90vh] overflow-y-auto">
//         <div className="flex items-center justify-between mb-6 border-b pb-4">
//           <div className="text-xl font-semibold text-customGreen">
//             {selectedDataId
//               ? "Edit Automation Message"
//               : "Create Automation Message"}
//           </div>
//           <button
//             onClick={close}
//             className="flex items-center justify-center w-8 h-8 text-lg font-medium text-gray-500 border border-gray-300 rounded-full hover:bg-red-500 hover:text-white hover:border-red-500 transition-all duration-200"
//           >
//             ×
//           </button>
//         </div>

//         {isLoading ? (
//           <div className="flex justify-center items-center h-64">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-customGreen"></div>
//           </div>
//         ) : (
//           <div className="space-y-6">
//             {/* Message Type */}
//             <div className="flex flex-col md:flex-row md:items-center gap-2">
//               <label className="w-full md:w-[20%] font-medium text-sm text-gray-700">
//                 Automation Message
//               </label>
//               <div className="w-full md:w-[80%]">
//                 <Select
//                   className="shadow-sm rounded-lg border border-gray-300"
//                   value={
//                     selectedMessage
//                       ? {
//                           label: selectedMessage.name,
//                           value: selectedMessage.id,
//                         }
//                       : null
//                   }
//                   onChange={handleMessageChange}
//                   options={messageTypes.map((item) => ({
//                     label: item.name,
//                     value: item.id,
//                   }))}
//                   placeholder="Select message type..."
//                   styles={customStyles}
//                   isSearchable
//                 />
//               </div>
//             </div>

//             {/* Lead Status */}
//             <div className="flex flex-col md:flex-row md:items-center gap-2">
//               <label className="w-full md:w-[20%] font-medium text-sm text-gray-700">
//                 Lead Status
//               </label>
//               <div className="w-full md:w-[80%]">
//                 <Select
//                   className="shadow-sm rounded-lg border border-gray-300"
//                   value={
//                     selectedStatus
//                       ? {
//                           label:
//                             leadStatuses.find((s) => s.ref === selectedStatus)
//                               ?.name || selectedStatus,
//                           value: selectedStatus,
//                         }
//                       : null
//                   }
//                   onChange={(option) => setSelectedStatus(option?.value || "")}
//                   options={leadStatuses.map((item) => ({
//                     label: item.name,
//                     value: item.ref,
//                   }))}
//                   placeholder="Select lead status..."
//                   styles={customStyles}
//                   isSearchable
//                 />
//               </div>
//             </div>

//             {/* Lead Quality */}
//             <div className="flex flex-col md:flex-row md:items-center gap-2">
//               <label className="w-full md:w-[20%] font-medium text-sm text-gray-700">
//                 Lead Quality
//               </label>
//               <div className="w-full md:w-[80%] border border-gray-300 rounded-lg shadow-sm px-2 py-1">
//                 <Select
//                   className="bg-transparent text-gray-700"
//                   value={selectedLevels}
//                   placeholder="Select lead quality levels..."
//                   onChange={setSelectedLevels}
//                   options={leadQualities.map((quality) => ({
//                     value: quality.ref,
//                     label: quality.name,
//                     ...quality,
//                   }))}
//                   isMulti={true}
//                   styles={customStyles}
//                   formatOptionLabel={(option) => (
//                     <div className="flex gap-2 items-center py-1">
//                       {interestLevel.find((item) => item.label === option.name)
//                         ?.image && (
//                         <img
//                           src={
//                             interestLevel.find(
//                               (item) => item.label === option.name
//                             )?.image
//                           }
//                           alt={option.name}
//                           className="w-5 h-5"
//                         />
//                       )}
//                       <span>{option.name}</span>
//                       <span
//                         className={`${getBackgroundClass(
//                           option.name
//                         )} font-bold`}
//                       ></span>
//                     </div>
//                   )}
//                 />
//               </div>
//             </div>

//             {/* Status Toggle */}
//           { selectedDataId && (
//               <div className="flex flex-col md:flex-row md:items-center gap-2">
//               <label className="w-full md:w-[20%] font-medium text-sm text-gray-700">
//                 Status
//               </label>

//               <label class="inline-flex items-center me-5 cursor-pointer">
//                 <input
//                   type="checkbox"
//                   value=""
//                   class="sr-only peer"
//                   checked={isActive}
//                   onChange={toggleActiveStatus}
//                 />
//                 <div class="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600 dark:peer-checked:bg-green-600"></div>
//                 <span
//                   className={`ml-3 text-sm font-medium ${
//                     isActive ? "text-customGreen" : "text-gray-500"
//                   }`}
//                 >
//                   {isActive ? "Active" : "Inactive"}
//                 </span>
//               </label>
//             </div>
//           )}

//             {/* Parameter Chips */}
//             {parameterChips.length > 0 && (
//               <div className="flex flex-col md:flex-row md:items-start gap-2">
//                 <label className="w-full md:w-[20%] font-medium text-sm text-gray-700 mt-2">
//                   Parameters
//                 </label>
//                 <div className="w-full md:w-[80%] flex flex-wrap gap-2">
//                   {parameterChips.map((chip) => (
//                     <button
//                       key={chip.id}
//                       onClick={() => insertParameterChip(chip.placeholder)}
//                       className="bg-customGreen text-white px-3 py-1.5 rounded-full text-sm font-medium hover:bg-opacity-90 transition duration-200 flex items-center"
//                       title={`Insert parameter: ${chip.label}`}
//                       type="button"
//                     >
//                       <span>{chip.label}</span>
//                       <span className="ml-1.5 bg-white text-customGreen rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
//                         {chip.placeholder.replace(/\{|\}/g, "")}
//                       </span>
//                     </button>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {/* Message Content */}
//             <div className="flex flex-col md:flex-row md:items-start gap-2">
//               <label className="w-full md:w-[20%] font-medium text-sm text-gray-700 mt-2">
//                 Message Content
//               </label>
//               <div className="w-full md:w-[80%]">
//                 <div className="mb-2 flex items-center text-green-600">
//                   <FaWhatsapp className="mr-2" size={20} />
//                   <span className="text-sm font-medium">WhatsApp Format</span>
//                 </div>

//                 <div className="  overflow-hidden">
//                   <ReactQuill
//                     ref={quillRef}
//                     value={messageContent}
//                     modules={modules}
//                     onChange={(content) => {
//                       setMessageContent(content);
//                       validateMessageContent(content);
//                     }}
//                     theme="snow"
//                     placeholder="Type your message here..."
//                     className="w-full h-[100px] rounded-md"
//                   />
//                 </div>

//                 {contentError && (
//                   <p className="text-red-500 text-sm mt-2 flex items-center">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="h-4 w-4 mr-1"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
//                       />
//                     </svg>
//                     {contentError}
//                   </p>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Action Buttons */}
//         <div className="flex justify-end gap-4 mt-8 pt-4 border-t">
//           <button
//             onClick={close}
//             className="px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition duration-200 font-medium"
//             disabled={isSubmitting}
//             type="button"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             disabled={
//               !!contentError ||
//               isLoading ||
//               isSubmitting ||
//               !selectedMessage ||
//               selectedLevels.length === 0 ||
//               !selectedStatus ||
//               messageContent === "" ||
//               messageContent === "<p><br></p>"
//             }
//             className={`${
//               contentError ||
//               isLoading ||
//               isSubmitting ||
//               !selectedMessage ||
//               selectedLevels.length === 0 ||
//               !selectedStatus ||
//               messageContent === "" ||
//               messageContent === "<p><br></p>"
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-customGreen hover:bg-green-600"
//             } text-white px-6 py-2.5 rounded-lg transition duration-200 font-medium flex items-center justify-center min-w-[180px]`}
//             type="button"
//           >
//             {isSubmitting ? (
//               <span className="flex items-center">
//                 <svg
//                   className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                 >
//                   <circle
//                     className="opacity-25"
//                     cx="12"
//                     cy="12"
//                     r="10"
//                     stroke="currentColor"
//                     strokeWidth="4"
//                   ></circle>
//                   <path
//                     className="opacity-75"
//                     fill="currentColor"
//                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                   ></path>
//                 </svg>
//                 {selectedDataId ? "Updating..." : "Creating..."}
//               </span>
//             ) : selectedDataId ? (
//               "Update"
//             ) : (
//               "Create & Send Request to Meta"
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AutoMessageModel;

// import React, { useState, useEffect, useRef, useMemo } from "react";
// import Select from "react-select";
// import { FaWhatsapp, FaTimes } from "react-icons/fa";
// import { HiOutlineCheck, HiOutlineX } from "react-icons/hi";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import AutoMessageService from "../../Services/AutoMessageService";
// import { interestLevel } from "../../../Enum";
// import { userId, userUid } from "../../Constant/Constant";
// import { showSuccessToast } from "../../Constant/Notification";

// const AutoMessageModel = ({ selectedDataId, isOpen, close }) => {
//   const [messageTypes, setMessageTypes] = useState([]);
//   const [selectedMessage, setSelectedMessage] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [selectedLevels, setSelectedLevels] = useState([]);
//   const [messageContent, setMessageContent] = useState("");
//   const [contentError, setContentError] = useState("");
//   const [leadStatuses, setLeadStatuses] = useState([]);
//   const [leadQualities, setLeadQualities] = useState([]);
//   const [parameterChips, setParameterChips] = useState([]);
//   const [isActive, setIsActive] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [platform, setPlatform] = useState("");
//   const [waTemplateId, setWaTemplateId] = useState("");
//   const [waTemplateName, setWaTemplateName] = useState("");
//   const [createdTimestamp, setCreatedTimestamp] = useState("");
//   const [updatedTimestamp, setUpdatedTimestamp] = useState("");
//   const [metaApproved, setMetaApproved] = useState("");
//   const [isUsed, setIsUsed] = useState(false);

//   const quillRef = useRef(null);

//   const modules = useMemo(
//     () => ({
//       toolbar: [
//         [{ header: [1, 2, 3, 4, 5, 6, false] }],
//         ["bold", "italic", "underline", "strike"],

//         [{ list: "ordered" }, { list: "bullet" }],
//         [{ color: [] }, { background: [] }],
//         ["link"],
//         ["clean"],
//         ["emoji"],

//       ],
//     }),
//     []
//   );

//   const customStyles = useMemo(
//     () => ({
//       control: (provided) => ({
//         ...provided,
//         backgroundColor: "white",
//         border: "1px solid #e5e7eb",
//         borderRadius: "0.5rem",
//         boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
//         minHeight: "42px",
//         "&:hover": {
//           borderColor: "#22C55E",
//         },
//       }),
//       valueContainer: (provided) => ({
//         ...provided,
//         padding: "2px 12px",
//       }),
//       option: (provided, state) => ({
//         ...provided,
//         backgroundColor: state.isSelected ? "#399E79" : "white",
//         color: state.isSelected ? "white" : "#374151",
//         cursor: "pointer",
//         fontSize: "0.95rem",
//         padding: "10px 16px",
//         "&:hover": {
//           backgroundColor: state.isSelected ? "#22C55E" : "#f3f4f6",
//         },
//       }),
//       multiValue: (provided) => ({
//         ...provided,
//         backgroundColor: "#e2f8e9",
//         borderRadius: "0.375rem",
//         padding: "1px 2px",
//       }),
//       multiValueLabel: (provided) => ({
//         ...provided,
//         color: "#399E79",
//         fontWeight: 500,
//         padding: "2px 6px",
//       }),
//       multiValueRemove: (provided) => ({
//         ...provided,
//         color: "#22C55E",
//         "&:hover": {
//           backgroundColor: "#d1f7dd",
//           color: "#16a34a",
//         },
//       }),
//       menu: (provided) => ({
//         ...provided,
//         borderRadius: "0.5rem",
//         boxShadow: "0 4px 14px rgba(0, 0, 0, 0.12)",
//         overflow: "hidden",
//       }),
//       menuList: (provided) => ({
//         ...provided,
//         padding: "4px",
//       }),
//     }),
//     []
//   );

//   useEffect(() => {
//     if (!isOpen) return;

//     const fetchData = async () => {
//       setIsLoading(true);
//       try {
//         const response = await AutoMessageService.creactionDataAutoMessage();
//         const {
//           messageType = [],
//           leadStatus = [],
//           leadQualities = [],
//         } = response.data || {};

//         setMessageTypes(messageType);
//         setLeadStatuses(leadStatus);
//         setLeadQualities(leadQualities);
      
//         console.log("Auto message creation data:", response.data);
//       } catch (error) {
//         console.error("Error fetching auto message creation data:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchData();
//   }, [isOpen]);

//   useEffect(() => {
//     if (!selectedDataId || !isOpen) return;

//     const fetchAutoMessage = async () => {
//       setIsLoading(true);
//       try {
//         const response = await AutoMessageService.getAutoMessageById(
//           selectedDataId
//         );
//         const data = response.data || {};

//         setIsActive(data.active === true);
//         setMessageContent(data.messageContent || "");

//         if (data.leadStatus) {
//           setSelectedStatus(data.leadStatus.ref || "");
//         }

//         if (data.leadQualities?.length) {
//           const qualityOptions = data.leadQualities.map((quality) => ({
//             value: quality.ref,
//             label: quality.name,
//             ...quality,
//           }));
//           setSelectedLevels(qualityOptions);
//         }

//         if (data.messageType) {
//           const messageTypeData = {
//             id: data.messageType.ref.split("/")[1],
//             name: data.messageType.name,
//             parameters:
//               data.dynamicValuesMapping?.map((item) => item.fieldName) || [],
//           };
//           setSelectedMessage(messageTypeData);
//           updateParameterChips(messageTypeData.parameters);
//         }

//         setPlatform(data.platform || "");
//         setWaTemplateId(data.waTemplateId || "");
//         setWaTemplateName(data.waTemplateName || "");
//         setCreatedTimestamp(data.createdTimestamp || "");
//         setUpdatedTimestamp(data.updatedTimestamp || "");
//         setMetaApproved(data.metaApproved || "");
//       } catch (error) {
//         console.error("Error fetching auto message:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchAutoMessage();
//   }, [selectedDataId, isOpen]);

//   useEffect(() => {
//     if (!isOpen || selectedDataId) return;

//     setSelectedMessage(null);
//     setSelectedStatus("");
//     setSelectedLevels([]);
//     setParameterChips([]);
//     setMessageContent("");
//     setIsActive(false);
//     setPlatform("");
//     setWaTemplateId("");
//     setWaTemplateName("");
//     setCreatedTimestamp("");
//     setUpdatedTimestamp("");
//     setMetaApproved("");
//     setContentError("");
//     setIsSubmitting(false);
//   }, [isOpen, selectedDataId]);

//   const updateParameterChips = (parameters) => {
//     if (!parameters?.length) {
//       setParameterChips([]);
//       return;
//     }

//     const chips = parameters.map((param, index) => ({
//       id: param,
//       label: param.replace(/_/g, " "),
//       placeholder: `{{${index + 1}}}`,
//     }));

//     setParameterChips(chips);
//   };

//   const handleMessageChange = (selectedOption) => {
//     if (!selectedOption) {
//       setSelectedMessage(null);
//       setParameterChips([]);
//       return;
//     }

//     const selected = messageTypes.find((mt) => mt.id === selectedOption.value);
//     if (!selected) return;

//     setSelectedMessage(selected);
//     updateParameterChips(selected.parameters);
//   };

//   const validateMessageContent = (content) => {
//     if (!content || content === "<p><br></p>") {
//       setContentError("Message content cannot be empty");
//       return false;
//     }

//     const plainText = content.replace(/<[^>]*>/g, "").trim();

//     const startsWithParam = /^\{\{\d+\}\}/.test(plainText);
//     const endsWithParam = /\{\{\d+\}\}$/.test(plainText);

//     if (startsWithParam) {
//       setContentError("Message cannot start with a parameter");
//       return false;
//     } else if (endsWithParam) {
//       setContentError("Message cannot end with a parameter");
//       return false;
//     } else {
//       setContentError("");
//       return true;
//     }
//   };

//   const getBackgroundClass = (name) => {
//     switch (name?.toLowerCase()) {
//       case "gold":
//         return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
//       case "silver":
//         return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
//       case "bronze":
//         return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
//       case "diamond":
//         return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
//       default:
//         return "text-black";
//     }
//   };

//   const insertParameterChip = (placeholder) => {
//     if (!quillRef.current) return;

//     const quill = quillRef.current.getEditor();
//     const range = quill.getSelection(true);
//     if (!range) {
//       quill.setSelection(0, 0);
//       return;
//     }

//     const currentContent = quill.getText();
//     const cursorPosition = range.index;

//     const wouldBeAtStart = cursorPosition === 0;
//     const wouldBeAtEnd = cursorPosition === currentContent.length;

//     if (wouldBeAtStart || wouldBeAtEnd) {
//       setContentError("Cannot add parameter at the beginning or end");
//       return;
//     }

//     quill.insertText(range.index, `${placeholder} `);
//     quill.setSelection(range.index + placeholder.length + 1);
//   };

//   const toggleActiveStatus = async () => {
//     try {
//       const payload = {
//         templateId: selectedDataId,
//         active: !isActive,
//       };

//       const response = await AutoMessageService.statusUpdateAutoMessage(
//         payload
//       );
//       if (response.status == 200) {
//         setIsActive(!isActive);
//         showSuccessToast("Status updated successfully");
//         close();
//       }
//     } catch (error) {
//       console.error("Error toggling auto message status:", error);
//     }
//     setIsActive(!isActive);
//   };

//   const handleSubmit = async () => {
//     if (!selectedMessage || !selectedLevels.length || !selectedStatus) {
//       return;
//     }

//     if (!validateMessageContent(messageContent)) {
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       const dynamicValuesMapping = parameterChips.map((chip, index) => ({
//         number: `${index + 1}`,
//         fieldName: chip.id,
//       }));

//       const payload = {
//         messageType: `messageType/${selectedMessage.id}`,
//         leadQualities: selectedLevels.map((level) => level.value || level.ref),
//         leadStatus: selectedStatus,
//         messageContent: messageContent,
//         dynamicValuesMapping: dynamicValuesMapping,
//       };

//       if (selectedDataId) {
//         Object.assign(payload, {
//           templateId: selectedDataId,
//           modifiedBy: userUid,
//           waTemplateName: waTemplateName,
//           waTemplateId: waTemplateId,
//         });

//         const response = await AutoMessageService.updateAutoMessage(payload);
//         if (response.status === 200) {
//           showSuccessToast("Automation message updated successfully");
//           close();
//         }
//       } else {
//         Object.assign(payload, {
//           createdBy: userUid,
//         });

//         const response = await AutoMessageService.createAutoMessage(payload);
//         if (response.status === 200) {
//           showSuccessToast("Automation message created successfully");
//           close();
//         }
//       }

//       close();
//     } catch (error) {
//       console.error(
//         "Error submitting form:",
//         error.response?.data || error.message || error
//       );
//       alert(
//         "Error: " +
//           (error.response?.data?.message ||
//             error.message ||
//             "Failed to save automation message")
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 py-6 z-50 backdrop-blur-sm">
//       <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-auto max-h-[90vh] overflow-y-auto animate-fadeIn">
//         {/* Header */}
//         <div className="sticky top-0 bg-white px-6 py-5 border-b border-gray-200 flex items-center justify-between rounded-t-xl z-10">
//           <div className="flex items-center">
//             <div className="h-8 w-1 bg-gradient-to-b from-customGreen to-custom-medium-green rounded-full mr-3"></div>
//             <h2 className="text-xl font-semibold text-gray-800">
//               {selectedDataId
//                 ? "Edit Automation Message"
//                 : "Create Automation Message"}
//             </h2>
//           </div>
//           <button
//             onClick={close}
//             className="flex items-center justify-center w-9 h-9 text-gray-500 rounded-full hover:bg-red-50 hover:text-red-500 transition-all duration-200"
//             aria-label="Close modal"
//           >
//             <FaTimes size={16} />
//           </button>
//         </div>

//         {isLoading ? (
//           <div className="flex flex-col justify-center items-center h-64 space-y-4">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-customGreen"></div>
//           </div>
//         ) : (
//           <div className="p-6 space-y-7">
//             <div className="space-y-6">
//               {/* Message Type */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
//                 <label className="font-medium text-gray-700 md:col-span-1">
//                   Automation Message
//                 </label>
//                 <div className="md:col-span-3">
//                   <Select
//                     value={
//                       selectedMessage
//                         ? {
//                             label: selectedMessage.name,
//                             value: selectedMessage.id,
//                           }
//                         : null
//                     }
//                     onChange={handleMessageChange}
//                     options={messageTypes.map((item) => ({
//                       label: item.name,
//                       value: item.id,
//                       isDisabled: item.isUsed,
//                     }))}
//                     placeholder="Select message type..."
//                     styles={customStyles}
//                     isSearchable
//                     className="w-full"
//                     isDisabled={selectedDataId !== null}
//                   />
//                 </div>
//               </div>

//               {/* Lead Status */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
//                 <label className="font-medium text-gray-700 md:col-span-1">
//                   Lead Status
//                 </label>
//                 <div className="md:col-span-3">
//                   <Select
//                     value={
//                       selectedStatus
//                         ? {
//                             label:
//                               leadStatuses.find((s) => s.ref === selectedStatus)
//                                 ?.name || selectedStatus,
//                             value: selectedStatus,
//                           }
//                         : null
//                     }
//                     onChange={(option) =>
//                       setSelectedStatus(option?.value || "")
//                     }
//                     options={leadStatuses.map((item) => ({
//                       label: item.name,
//                       value: item.ref,
//                     }))}
//                     placeholder="Select lead status..."
//                     styles={customStyles}
//                     isSearchable
//                     className="w-full"
//                   />
//                 </div>
//               </div>

//               {/* Lead Quality */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
//                 <label className="font-medium text-gray-700 md:col-span-1">
//                   Lead Quality
//                 </label>
//                 <div className="md:col-span-3">
//                   <Select
//                     value={selectedLevels}
//                     placeholder="Select lead quality levels..."
//                     onChange={setSelectedLevels}
//                     options={leadQualities.map((quality) => ({
//                       value: quality.ref,
//                       label: quality.name,
//                       ...quality,
//                     }))}
//                     isMulti={true}
//                     styles={customStyles}
//                     formatOptionLabel={(option) => (
//                       <div className="flex gap-2 items-center py-1">
//                         {interestLevel.find(
//                           (item) => item.label === option.name
//                         )?.image && (
//                           <img
//                             src={
//                               interestLevel.find(
//                                 (item) => item.label === option.name
//                               )?.image
//                             }
//                             alt={option.name}
//                             className="w-5 h-5"
//                           />
//                         )}
//                         <span className="font-medium">{option.name}</span>
//                         <span
//                           className={`${getBackgroundClass(
//                             option.name
//                           )} font-bold`}
//                         ></span>
//                       </div>
//                     )}
//                     className="w-full"
//                   />
//                 </div>
//               </div>

//               {/* Status Toggle */}
//               {selectedDataId && (
//                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
//                   <label className="font-medium text-gray-700 md:col-span-1">
//                     Status
//                   </label>
//                   <div className="md:col-span-3">
//                     <label class="inline-flex items-center me-5 cursor-pointer">
//                       <input
//                         type="checkbox"
//                         value=""
//                         class="sr-only peer"
//                         checked={isActive}
//                         onChange={toggleActiveStatus}
//                       />
//                       <div class="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600 dark:peer-checked:bg-green-600"></div>
//                       <span
//                         className={`ml-3 text-sm font-medium ${
//                           isActive ? "text-customGreen" : "text-gray-500"
//                         }`}
//                       >
//                         {isActive ? "Active" : "Inactive"}
//                       </span>
//                     </label>
//                   </div>
//                 </div>
//               )}

//               {/* Parameter Chips */}
//               {parameterChips.length > 0 && (
//                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
//                   <label className="font-medium text-gray-700 md:col-span-1 pt-2">
//                     Parameters
//                   </label>
//                   <div className="md:col-span-3 flex flex-wrap gap-2">
//                     {parameterChips.map((chip) => (
//                       <button
//                         key={chip.id}
//                         onClick={() => insertParameterChip(chip.placeholder)}
//                         className="group bg-green-50 border border-green-200 hover:bg-green-100 text-customGreen px-3 py-2 rounded-full text-sm font-medium transition duration-200 flex items-center"
//                         title={`Insert parameter: ${chip.label}`}
//                         type="button"
//                       >
//                         <span>@{chip.label}</span>
//                         <span className="ml-2 bg-customGreen text-white rounded-md px-2 py-0.5 text-xs font-bold  transition-colors">
//                           {chip.placeholder.replace(/\{|\}/g, "")}
//                         </span>
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {/* Message Content */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start pt-2">
//                 <label className="font-medium text-gray-700 md:col-span-1 pt-2">
//                   Message Content
//                 </label>
//                 <div className="md:col-span-3">
//                   <div className="mb-3 flex items-center text-customGreen bg-green-50 px-4 py-2 rounded-lg">
//                     <FaWhatsapp className="mr-2" size={18} />
//                     <span className="text-sm font-medium">WhatsApp Format</span>
//                   </div>

//                   <div className="border border-gray-300 rounded-lg overflow-hidden shadow-sm  transition-all duration-200">
//                     <ReactQuill
//                       ref={quillRef}
//                       value={messageContent}
//                       modules={modules}
//                       onChange={(content) => {
//                         setMessageContent(content);
//                         validateMessageContent(content);
//                       }}
//                       theme="snow"

//                       placeholder="Type your message here..."
//                       className="w-full h-[180px]"
//                     />
//                   </div>

//                   {contentError && (
//                     <div className="flex items-center mt-2 text-red-500 bg-red-50 px-3 py-2 rounded-md">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="h-5 w-5 mr-2 flex-shrink-0"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
//                         />
//                       </svg>
//                       <span className="text-sm">{contentError}</span>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Action Buttons */}
//         <div className="sticky bottom-0 bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-4 rounded-b-xl">
//           <button
//             onClick={close}
//             className="px-5 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition duration-200 font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
//             disabled={isSubmitting}
//             type="button"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             disabled={
//               !!contentError ||
//               isLoading ||
//               isSubmitting ||
//               !selectedMessage ||
//               selectedLevels.length === 0 ||
//               !selectedStatus ||
//               messageContent === "" ||
//               messageContent === ""
//             }
//             className={`${
//               contentError ||
//               isLoading ||
//               isSubmitting ||
//               !selectedMessage ||
//               selectedLevels.length === 0 ||
//               !selectedStatus ||
//               messageContent === "" ||
//               messageContent === ""
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-customGreen"
//             } text-white px-6 py-2.5 rounded-lg transition duration-200 font-medium flex items-center justify-center min-w-[180px] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500`}
//             type="button"
//           >
//             {isSubmitting ? (
//               <span className="flex items-center">
//                 <svg
//                   className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                 >
//                   <circle
//                     className="opacity-25"
//                     cx="12"
//                     cy="12"
//                     r="10"
//                     stroke="currentColor"
//                     strokeWidth="4"
//                   ></circle>
//                   <path
//                     className="opacity-75"
//                     fill="currentColor"
//                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                   ></path>
//                 </svg>
//                 {selectedDataId ? "Updating..." : "Creating..."}
//               </span>
//             ) : selectedDataId ? (
//               "Update Message"
//             ) : (
//               "Create & Send Request to Meta"
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AutoMessageModel;

// Updated insertParameter function and related state
import React, { useState, useEffect, useRef, useMemo } from "react";
import Select from "react-select";
import { FaWhatsapp, FaTimes } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "quill-emoji/dist/quill-emoji.css"; 
import "quill-emoji"; 
import AutoMessageService from "../../Services/AutoMessageService";
import { interestLevel } from "../../../Enum/LeadEnumConstants";
import { userId, userUid } from "../../Constant/Constant";
import { showSuccessToast } from "../../Constant/Notification";


const stripHtml = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const AutoMessageModel = ({ selectedDataId, isOpen, close }) => {
  const [messageTypes, setMessageTypes] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedLevels, setSelectedLevels] = useState([]);
  const [messageContent, setMessageContent] = useState("");
  const [contentError, setContentError] = useState("");
  const [leadStatuses, setLeadStatuses] = useState([]);
  const [leadQualities, setLeadQualities] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [platform, setPlatform] = useState("");
  const [waTemplateId, setWaTemplateId] = useState("");
  const [waTemplateName, setWaTemplateName] = useState("");
  const [createdTimestamp, setCreatedTimestamp] = useState("");
  const [updatedTimestamp, setUpdatedTimestamp] = useState("");
  const [metaApproved, setMetaApproved] = useState("");
  const [parameterClickCount, setParameterClickCount] = useState(0); 
  const [insertedParameters, setInsertedParameters] = useState([]); 
  const [parameterMap, setParameterMap] = useState({});
  const [quillHTML, setQuillHTML] = useState("");


  const quillRef = useRef(null);

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"],
        ["emoji"], 
      ],
      keyboard: {
        bindings: {
          handleEnter: {
            key: 13,
            handler: function (range, context) {
              const quill = this.quill;
              // Insert plain new line
              quill.insertText(range.index, "\n", 'user');
              // Clear ALL formatting for the new line
              quill.formatLine(range.index + 1, 1, {
                list: false,
                blockquote: false,
                'code-block': false,
                indent: false,
                align: false,
              });
              quill.setSelection(range.index + 1, 0);
              return false;
            },
          },
        },
      },
      
      "emoji-toolbar": true,
      "emoji-textarea": true,
      "emoji-shortname": true,
    }),
    []
  );
  

  const customStyles = useMemo(
    () => ({
      control: (provided) => ({
        ...provided,
        backgroundColor: "white",
        border: "1px solid #e5e7eb",
        borderRadius: "0.5rem",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
        minHeight: "42px",
        "&:hover": {
          borderColor: "#22C55E",
        },
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: "2px 12px",
      }),
      option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "#399E79" : "white",
                color: state.isSelected ? "white" : "#374151",
                cursor: "pointer",
                fontSize: "0.95rem",
                padding: "10px 16px",
                "&:hover": {
                  backgroundColor: state.isSelected ? "#22C55E" : "#f3f4f6",
                },
              }),
      multiValue: (provided) => ({
        ...provided,
        backgroundColor: "#e2f8e9",
        borderRadius: "0.375rem",
        padding: "1px 2px",
      }),
      multiValueLabel: (provided) => ({
        ...provided,
        color: "#399E79",
        fontWeight: 500,
        padding: "2px 6px",
      }),
      multiValueRemove: (provided) => ({
        ...provided,
        color: "#22C55E",
        "&:hover": {
          backgroundColor: "#d1f7dd",
          color: "#16a34a",
        },
      }),
      menu: (provided) => ({
        ...provided,
        borderRadius: "0.5rem",
        boxShadow: "0 4px 14px rgba(0, 0, 0, 0.12)",
        overflow: "hidden",
      }),
      menuList: (provided) => ({
        ...provided,
        padding: "4px",
      }),
    }),
    []
  );

  useEffect(() => {
    if (!isOpen) return;

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await AutoMessageService.creactionDataAutoMessage();
        const { messageType = [], leadStatus = [], leadQualities = [] } =
          response.data || {};

        setMessageTypes(messageType);
        setLeadStatuses(leadStatus);
        setLeadQualities(leadQualities);
        console.log("Auto message creation data:", response.data);
      } catch (error) {
        console.error("Error fetching auto message creation data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [isOpen]);

  useEffect(() => {
    if (!selectedDataId || !isOpen) return;

    const fetchAutoMessage = async () => {
      setIsLoading(true);
      try {
        const response = await AutoMessageService.getAutoMessageById(
          selectedDataId
        );
        const data = response.data || {};

        setIsActive(data.active === true);
   
        setMessageContent(data.messageContent ? stripHtml(data.messageContent) : "");

        if (data.leadStatus) {
          setSelectedStatus(data.leadStatus.ref || "");
        }

        if (data.leadQualities?.length) {
          const qualityOptions = data.leadQualities.map((quality) => ({
            value: quality.ref,
            label: quality.name,
            ...quality,
          }));
          setSelectedLevels(qualityOptions);
        }

        if (data.messageType) {
          const messageTypeData = {
            id: data.messageType.ref.split("/")[1],
            name: data.messageType.name,
            parameters:
              data.dynamicValuesMapping?.map((item) => item.fieldName) || [],
          };
          setSelectedMessage(messageTypeData);
        
          const paramMap = {};
          data.dynamicValuesMapping?.forEach((item, index) => {
            paramMap[item.fieldName] = parseInt(item.number);
          });
          setParameterMap(paramMap);
          
          setInsertedParameters(
            data.dynamicValuesMapping?.map((item) => ({
              placeholder: `{{${item.number}}}`,
              fieldName: item.fieldName,
            })) || []
          );

          const maxNumber = Math.max(
            0,
            ...Object.values(paramMap).map(num => parseInt(num))
          );
          setParameterClickCount(maxNumber || 0);
        }

        setPlatform(data.platform || "");
        setWaTemplateId(data.waTemplateId || "");
        setWaTemplateName(data.waTemplateName || "");
        setCreatedTimestamp(data.createdTimestamp || "");
        setUpdatedTimestamp(data.updatedTimestamp || "");
        setMetaApproved(data.metaApproved || "");
      } catch (error) {
        console.error("Error fetching auto message:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAutoMessage();
  }, [selectedDataId, isOpen]);

  useEffect(() => {
    if (!isOpen || selectedDataId) return;

    setSelectedMessage(null);
    setSelectedStatus("");
    setSelectedLevels([]);
    setInsertedParameters([]);
    setParameterClickCount(0);
    setParameterMap({});
    setMessageContent("");
    setIsActive(false);
    setPlatform("");
    setWaTemplateId("");
    setWaTemplateName("");
    setCreatedTimestamp("");
    setUpdatedTimestamp("");
    setMetaApproved("");
    setContentError("");
    setIsSubmitting(false);
  }, [isOpen, selectedDataId]);

  const handleMessageChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedMessage(null);
      setInsertedParameters([]);
      setParameterClickCount(0);
      setParameterMap({});
      return;
    }

    const selected = messageTypes.find((mt) => mt.id === selectedOption.value);
    if (!selected) return;

    setSelectedMessage(selected);
    setInsertedParameters([]);
    setParameterClickCount(0);
    setParameterMap({});
  };

  const validateMessageContent = (content) => {
    if (!content || content.trim() === "") {
      setContentError("Message content cannot be empty");
      return false;
    }
  
    const plainText = content.trim();
  
    if (selectedDataId) {
     
      const startsWithParam = /^\{\{\d+\}\}/.test(plainText);
      const endsWithParam = /\{\{\d+\}\}$/.test(plainText);
  
      if (startsWithParam) {
        setContentError("Message cannot start with a parameter");
        return false;
      } else if (endsWithParam) {
        setContentError("Message cannot end with a parameter");
        return false;
      }
    } else {
    
      const endsWithParam = /\{\{\d+\}\}$/.test(plainText);
      if (endsWithParam) {
        setContentError("Message must end with text");
        return false;
      }
    }
  
    setContentError("");
    return true;
  };

  const getBackgroundClass = (name) => {
    switch (name?.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };
  

  const insertParameter = (fieldName) => {
    if (!quillRef.current) return;
  
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection(true);
    if (!range) {
      quill.setSelection(0, 0);
      return;
    }
  
    const currentContent = quill.getText();
    const cursorPosition = range.index;
  
 
    if (selectedDataId) {
      const wouldBeAtStart = cursorPosition === 0;
      const wouldBeAtEnd = cursorPosition >= currentContent.length - 1;
  
      if (wouldBeAtStart) {
        setContentError("Cannot add parameter at the beginning");
        return;
      }
      if (wouldBeAtEnd) {
        setContentError("Cannot add parameter at the end");
        return;
      }
    }
  
    let paramNumber;

    if (parameterMap[fieldName]) {
      paramNumber = parameterMap[fieldName];
    } else {
      const newNumber = parameterClickCount + 1;
      setParameterClickCount(newNumber);
      paramNumber = newNumber;
      

      setParameterMap(prev => ({
        ...prev,
        [fieldName]: newNumber
      }));
      
      setInsertedParameters(prev => [
        ...prev,
        {
          placeholder: `{{${newNumber}}}`,
          fieldName
        }
      ]);
    }
    
    const placeholder = `{{${paramNumber}}}`;
    quill.insertText(range.index, `${placeholder} `);
    quill.setSelection(range.index + placeholder.length + 1);
  };

  const toggleActiveStatus = async () => {
    try {
      const payload = {
        templateId: selectedDataId,
        active: !isActive,
      };

      const response = await AutoMessageService.statusUpdateAutoMessage(payload);
      if (response.status === 200) {
        setIsActive(!isActive);
        showSuccessToast("Status updated successfully");
        close();
      }
    } catch (error) {
      console.error("Error toggling auto message status:", error);
    }
  };

  const convertHtmlToPlainText = (html) => {
    return html
      .replace(/<p><br><\/p>/g, '\r\n')
      .replace(/<p>/g, '')
      .replace(/<\/p>/g, '\r\n')
      .replace(/<br\s*\/?>/gi, '\r\n')
      .trim();
  };
  
  const handleSubmit = async () => {
    if (!selectedMessage || !selectedLevels.length || !selectedStatus) {
      return;
    }
  
    if (!validateMessageContent(messageContent)) {
      return;
    }
  
    setIsSubmitting(true);
  
    try {
    
      const usedPlaceholders = [...messageContent.matchAll(/{{(\d+)}}/g)].map(
        (match) => match[1]
      );
  
      const dynamicValuesMapping = insertedParameters
        .filter((param) => {
          const numberMatch = param.placeholder.match(/{{(\d+)}}/);
          if (!numberMatch) return false;
          return usedPlaceholders.includes(numberMatch[1]);
        })
        .map((param) => {
          const numberMatch = param.placeholder.match(/{{(\d+)}}/);
          return {
            number: numberMatch[1],
            fieldName: param.fieldName,
          };
        });
  
      const payload = {
        messageType: `messageType/${selectedMessage.id}`,
        leadQualities: selectedLevels.map((level) => level.value || level.ref),
        leadStatus: selectedStatus,
        messageContent: convertHtmlToPlainText(messageContent),
        dynamicValuesMapping,
      };


  
      if (selectedDataId) {
        // Object.assign(payload, {
        //   templateId: selectedDataId,
        //   modifiedBy: userUid,
        //   waTemplateName,
        //   waTemplateId,
        // });

        const updatePayload = {
          templateId: selectedDataId,
          modifiedBy: userUid,
          leadQualities: selectedLevels.map((level) => level.value || level.ref),
          leadStatus: selectedStatus,
        }
  
        const response = await AutoMessageService.updateAutoMessage(updatePayload);
        if (response.status === 201) {
          showSuccessToast("Automation message updated successfully");
          close();
        }
      } else {
        Object.assign(payload, {
          createdBy: userUid,
        });
  
  
        const response = await AutoMessageService.createAutoMessage(payload);
        if (response.status === 201) {
          showSuccessToast("Automation message created successfully");
          close();
        }
      }
    } catch (error) {
      console.error(
        "Error submitting form:",
        error.response?.data || error.message || error
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Function to get the parameter count for display on the button
  const getParameterUsageCount = (fieldName) => {
    return parameterMap[fieldName] || "";
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 py-6 z-50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-auto max-h-[90vh] overflow-y-auto animate-fadeIn">
        {/* Header */}
        <div className="sticky top-0 bg-white px-6 py-5 border-b border-gray-200 flex items-center justify-between rounded-t-xl z-10">
          <div className="flex items-center">
            <div className="h-8 w-1 bg-gradient-to-b from-customGreen to-custom-medium-green rounded-full mr-3"></div>
            <h2 className="text-xl font-semibold text-gray-800">
              {selectedDataId
                ? "Edit Automation Message"
                : "Create Automation Message"}
            </h2>
          </div>
          <button
            onClick={close}
            className="flex items-center justify-center w-9 h-9 text-gray-500 rounded-full hover:bg-red-50 hover:text-red-500 transition-all duration-200"
            aria-label="Close modal"
          >
            <FaTimes size={16} />
          </button>
        </div>

        {isLoading ? (
          <div className="flex flex-col justify-center items-center h-64 space-y-4">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-customGreen"></div>
          </div>
        ) : (
          <div className="p-6 space-y-7">
            <div className="space-y-6">
              {/* Message Type */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                <label className="font-medium text-gray-700 md:col-span-1">
                  Automation Message
                </label>
                <div className="md:col-span-3">
                  <Select
                    value={
                      selectedMessage
                        ? {
                            label: selectedMessage.name,
                            value: selectedMessage.id,
                          }
                        : null
                    }
                    onChange={handleMessageChange}
                    options={messageTypes.map((item) => ({
                      label: item.name,
                      value: item.id,
                      isDisabled: item.isUsed,
                    }))}
                    placeholder="Select message type..."
                    styles={customStyles}
                    isSearchable
                    className="w-full"
                    isDisabled={selectedDataId !== null}
                  />
                </div>
              </div>

              {/* Lead Status */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                <label className="font-medium text-gray-700 md:col-span-1">
                  Lead Status
                </label>
                <div className="md:col-span-3">
                  <Select
                    value={
                      selectedStatus
                        ? {
                            label:
                              leadStatuses.find((s) => s.ref === selectedStatus)
                                ?.name || selectedStatus,
                            value: selectedStatus,
                          }
                        : null
                    }
                    onChange={(option) =>
                      setSelectedStatus(option?.value || "")
                    }
                    options={leadStatuses.map((item) => ({
                      label: item.name,
                      value: item.ref,
                    }))}
                    placeholder="Select lead status..."
                    styles={customStyles}
                    isSearchable
                    className="w-full"
                  />
                </div>
              </div>

              {/* Lead Quality */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                <label className="font-medium text-gray-700 md:col-span-1">
                  Lead Quality
                </label>
                <div className="md:col-span-3">
                  <Select
                    value={selectedLevels}
                    placeholder="Select lead quality levels..."
                    onChange={setSelectedLevels}
                    options={leadQualities.map((quality) => ({
                      value: quality.ref,
                      label: quality.name,
                      ...quality,
                    }))}
                    isMulti={true}
                    styles={customStyles}
                    formatOptionLabel={(option) => (
                      <div className="flex gap-2 items-center py-1">
                        {interestLevel.find(
                          (item) => item.label === option.name
                        )?.image && (
                          <img
                            src={
                              interestLevel.find(
                                (item) => item.label === option.name
                              )?.image
                            }
                            alt={option.name}
                            className="w-5 h-5"
                          />
                        )}
                        <span className="font-medium">{option.name}</span>
                        <span
                          className={`${getBackgroundClass(
                            option.name
                          )} font-bold`}
                        ></span>
                      </div>
                    )}
                    className="w-full"
                  />
                </div>
              </div>

              {/* Status Toggle */}
              {selectedDataId && (
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                  <label className="font-medium text-gray-700 md:col-span-1">
                    Status
                  </label>
                  <div className="md:col-span-3">
                    <label className="inline-flex items-center me-5 cursor-pointer">
                      <input
                        type="checkbox"
                        value=""
                        className="sr-only peer"
                        checked={isActive}
                        onChange={toggleActiveStatus}
                      />
                      <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600 dark:peer-checked:bg-green-600"></div>
                      <span
                        className={`ml-3 text-sm font-medium ${
                          isActive ? "text-customGreen" : "text-gray-500"
                        }`}
                      >
                        {isActive ? "Active" : "Inactive"}
                      </span>
                    </label>
                  </div>
                </div>
              )}

              {/* Parameters */}
              {selectedMessage?.parameters?.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
                  <label className="font-medium text-gray-700 md:col-span-1 pt-2">
                    Parameters
                  </label>
                  <div className="md:col-span-3 flex flex-wrap gap-2">
                    {selectedMessage.parameters.map((param) => (
                      <button
                        key={param}
                        onClick={() => insertParameter(param)}
                        className="group bg-green-50 border border-green-200 hover:bg-green-100 text-customGreen px-3 py-2 rounded-full text-sm font-medium transition duration-200 flex items-center"
                        title={`Insert parameter: ${param.replace(/_/g, " ")}`}
                        type="button"
                      >
                        <span>@{param.replace(/_/g, " ")}</span>
                        {parameterMap[param] && (
                          <span className="inline-flex items-center justify-center ml-2 w-5 h-5 bg-green-600 text-white text-xs rounded-full">
                            {parameterMap[param]}
                          </span>
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Message Content */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start pt-2">
                <label className="font-medium text-gray-700 md:col-span-1 pt-2">
                  Message Content
                </label>
                <div className="md:col-span-3">
                  <div className="mb-3 flex items-center text-customGreen bg-green-50 px-4 py-2 rounded-lg">
                    <FaWhatsapp className="mr-2" size={18} />
                    <span className="text-sm font-medium">WhatsApp Format</span>
                  </div>

                  <div className="border border-gray-300 rounded-lg overflow-hidden shadow-sm transition-all duration-200">
<ReactQuill
  ref={quillRef}
  value={messageContent}
  modules={modules}
  readOnly={selectedDataId !== null}
  onChange={(content, delta, source, editor) => {
    setMessageContent(content); // only set raw HTML here
    const plainText = editor.getText().trim();
    validateMessageContent(plainText);
  }}
  theme="snow"
  placeholder="Type your message here..."
  className="w-full h-[180px]"
/>


                  </div>

                  {contentError && (
                    <div className="flex items-center mt-2 text-red-500 bg-red-50 px-3 py-2 rounded-md">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-2 flex-shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                      </svg>
                      <span className="text-sm">{contentError}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="sticky bottom-0 bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-4 rounded-b-xl">
          <button
            onClick={close}
            className="px-5 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition duration-200 font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
            disabled={isSubmitting}
            type="button"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={
              !!contentError ||
              isLoading ||
              isSubmitting ||
              !selectedMessage ||
              selectedLevels.length === 0 ||
              !selectedStatus ||
              messageContent === "" ||
              messageContent.trim() === ""
            }
            className={`${
              contentError ||
              isLoading ||
              isSubmitting ||
              !selectedMessage ||
              selectedLevels.length === 0 ||
              !selectedStatus ||
              messageContent === "" ||
              messageContent.trim() === ""
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-customGreen"
            } text-white px-6 py-2.5 rounded-lg transition duration-200 font-medium flex items-center justify-center min-w-[180px] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500`}
            type="button"
          >
         
            {isSubmitting ? (
              <span className="flex items-center">
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                {selectedDataId ? "Updating..." : "Creating..."}
              </span>
            ) : selectedDataId ? (
              "Update Message"
            ) : (
              "Create & Send Request to Meta"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutoMessageModel;
